import Col from "../../../components/element/col";
import Container from "../../../components/element/container";
import Icon from "../../../components/element/icon";
import Row from "../../../components/element/row";

export default function OrderTimeline({ order }) {
  const timelineList = {
    failed: [],
    unpaid: [
      {
        label: "Payment failed",
        icon_class: "unpaid --active",
        icon: "famicons:radio-button-on-sharp",
        date: order.created_at,
        description: "Your payment was unsuccessful.",
      },
    ],
    pending: [
      {
        label: "Preparing to ship",
        icon_class: "pending --active",
        icon: "famicons:radio-button-on-sharp",
        date: order.created_at,
        description: "Your order is confirmed.",
      },
    ],
    processing: [
      {
        label: "On the way",
        icon: "material-symbols-light:local-shipping",
        tracking_no: order.order_properties.delivery_info.tracking_url,
        date: order.processing_at,
        icon_class: "ship --active",
        description: "The shipment is on its way.",
      },
      {
        label: "Preparing to ship",
        icon_class: "pending",
        icon: "famicons:radio-button-on-sharp",
        date: order.created_at,
        description: "Your order is confirmed.",
      },
    ],
    completed: [
      {
        label: "Delivered",
        icon_class: "deliver --active",
        icon: "mdi:package-delivered",
        date: "16 Feb 2025 12:10 PM",
        description: "Your order is delivered.",
        date: order.completed_at,
      },
      {
        label: "On the way",
        icon_class: "ship",
        icon: "material-symbols-light:local-shipping",
        tracking_no: "60850731503285",
        date: order.processing_at,
        description: "The shipment is on its way.",
      },
      {
        label: "Preparing to ship",
        icon_class: "pending",
        icon: "famicons:radio-button-on-sharp",
        date: order.created_at,
        description: "Your order is confirmed.",
      },
    ],
  };

  return (
    timelineList[order.payment_status === "pending" ? "unpaid" : order.status]
      ?.length > 0 && (
      <Container tag="article" className="order-timeline">
        <Col className="v-flex gap-2">
          {timelineList[
            order.payment_status === "pending" ? "unpaid" : order.status
          ].map((timeline, timelineIndex) => (
            <Col className="v-flex gap-2" key={timelineIndex}>
              <Row className="h-flex items-baseline flex-nowrap gap-3">
                <Col className="_col icon">
                  <Icon
                    icon={timeline.icon}
                    className={`_svg ${timeline.icon_class} ${timeline.icon_class}`}
                  />
                  {/* {timelineIndex + 1 !== timelineList.length && (
                  <article className="_line" />
                )} */}
                </Col>
                <Col className="v-flex gap-2">
                  <h5
                    className={`_label timeline-title flex items-center gap-3 ${
                      order.payment_status === "pending" ? "--failed" : ""
                    }`}
                  >
                    {timeline.label}{" "}
                    {timeline.tracking_no && (
                      <a
                        href={timeline.tracking_no}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {" | "}
                        <span>Tracking URL</span>
                        <Icon icon="eva:link-2-fill" className="_svg link" />
                      </a>
                    )}
                  </h5>
                </Col>
              </Row>
              <Col
                className={`_col description ${
                  timelineIndex + 1 !== timelineList.length ? "--line" : ""
                }`}
              >
                <p className="_label timeline-date">{timeline.date}</p>
                <p className="_label timeline-description mt-1">
                  {timeline.description}
                </p>
              </Col>
            </Col>
          ))}
        </Col>
      </Container>
    )
  );
}
